import { useUploadReplaceBlueprintModal } from "./useUploadReplaceBlueprintModal"

export function withReplaceUploadBlueprintModal(Component) {

	return function WrappedComponent(props) {
		const {
			UploadReplaceBlueprintModal,
			openUploadReplaceBlueprintModal,
		} = useUploadReplaceBlueprintModal({
			offerDetail: props.offerDetail,
		})
		return (

			<Component
				{...props}
				UploadReplaceBlueprintModal={UploadReplaceBlueprintModal}
				openUploadReplaceBlueprintModal={openUploadReplaceBlueprintModal}
			/>
		)
	}

}
